export class AndroidNotificationsService {
    IsAndroidNotificationsAvailable() {
        return navigator.AndroidNotifications !== undefined;
    }
    CheckNotificationPermissionAsync() {
        if (this.IsAndroidNotificationsAvailable()) {
            return navigator.AndroidNotifications.CheckNotificationPermissionAsync();
        }
        return Promise.resolve(false);
    }
    RequestNotificationPermissionAsync() {
        if (this.IsAndroidNotificationsAvailable()) {
            return navigator.AndroidNotifications.RequestNotificationPermissionAsync();
        }
        return Promise.resolve(false);
    }
    GetDeviceFirebaseTokenAsync() {
        if (this.IsAndroidNotificationsAvailable()) {
            return navigator.AndroidNotifications.GetDeviceFirebaseTokenAsync();
        }
        return Promise.resolve(null);
    }
    GetNotificationsQueueAsync() {
        if (this.IsAndroidNotificationsAvailable()) {
            return navigator.AndroidNotifications.GetNotificationsQueueAsync();
        }
        return Promise.resolve(null);
    }
    GetServiceName() {
        return AndroidNotificationsService.ServiceName;
    }
}
AndroidNotificationsService.ServiceName = "AndroidNotificationsService";
//# sourceMappingURL=AndroidNotificationService.js.map